<template>
  <div class="product-search-container">
    <!-- <div class="breadcrumbs">
      <router-link to="/" class="nav-link">Home Page</router-link>/
      <router-link to="/" class="nav-link disabled">Product Search</router-link>
    </div>-->
    <div class="download-search-results">
      <a href @click.prevent="downloadAllResults">Results</a>
    </div>
    <div class="product-count">
      <br />
      <strong>{{ productCount }} Product Lines</strong>
    </div>
    <div class="product-search-sidebar">
      <component-product-filter></component-product-filter>
    </div>
    <div class="product-search-body">
      <component-product-list></component-product-list>
    </div>
  </div>
</template>


<script>
import ProductFilter from "../components/ProductFilter.vue";
import ProductList from "../components/ProductList.vue";
import axios from "axios";
import FileSaver from 'file-saver';


export default {
  components: {
    "component-product-list": ProductList,
    "component-product-filter": ProductFilter
  },
  computed: {
    productCount() {
      return this.$store.state.productCount;
    }
  },
  methods: {
    // downloadResults() {
    //   let url = "http://localhost:8000/api/v1/ProductListDownload/"
    //   axios
    //     .get(url, {
    //       headers: {
    //         Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
    //       }
    //     }).then(response => {
    //       var blob = new Blob([response.data], {type: 'text/csv'})
    //       FileSaver.saveAs(blob, "All-SunSpec-Certs.csv")
    //     }) 
    // },
    downloadAllResults() {
      // console.log("download all results: " + this.$store.state.queryStringForDownload)
      this.$store.commit("callAPIDownloadResults", this.$store.state.queryStringForDownload)
      // if (this.$store.state.apiDataDownload) {
      //     var blob = new Blob([this.$store.state.apiDataDownload], {type: 'application/json	'})
      //     FileSaver.saveAs(blob, "SunSpec-Certs.json")        
      // }
    }
  }
};
</script>


<style scoped>
.product-search-container {
  display: grid;
  grid-template-columns: 50px 250px 25px 1000px 25px;
  grid-template-rows: 25px auto 25px;
}

.product-search-sidebar {
  grid-column: 2 / 3;
  grid-row: 1 / 3;
}

.product-search-body {
  grid-column: 4 / span 2;
  grid-row: 1 / span 2;
}

.breadcrumbs {
  grid-column: 2 / span 3;
  grid-row: 1 / 2;
}

.nav-link {
  display: inline;
  padding: 0;
  padding-right: 5px;
}

.download-search-results {
  grid-column: 4 / 5;
  grid-row: 1 / 2;
}

#sort-by-button {
  float: right;
}

.product-count {
  grid-column: 4 / 5;
  grid-row: 1 / 2;
}

a {
  color: #1d4679;
}
</style>